// MDS - acronym for Modal Data Set

export class MDSModalContainer {
    constructor ({
        disableCloseEventsOnContainer = false
    } = {}) {
        this.disableCloseEventsOnContainer = disableCloseEventsOnContainer
    }
}

export class MDSModalConfirmDecisionModel extends MDSModalContainer {
    constructor (props) {
        const {
            confirmationHandler, // [Function, isRequired]
            title = 'Are you sure?', // [String]
            description = '', // [String]
            btnTextCancel = 'Cancel', // [String]
            btnTextConfirm = 'Delete it', // [String]
            closeOnlyByConfirmButton = false // [Boolean]
        } = props
        super({
            disableCloseEventsOnContainer: closeOnlyByConfirmButton
        })

        this.confirmationHandler = confirmationHandler
        this.title = title
        this.description = description
        this.btnTextCancel = btnTextCancel
        this.btnTextConfirm = btnTextConfirm
        this.closeOnlyByConfirmButton = closeOnlyByConfirmButton
    }
}

export class MDSModalEditFieldModel extends MDSModalContainer {
    constructor (props) {
        const {
            field, // [Object, isRequired]
            parent, // [String, isRequired]
            scope, // [String, isRequired]
            usedKeys, // [Array, isRequired]
        } = props
        super()

        this.field = field
        this.parent = parent
        this.scope = scope
        this.usedKeys = usedKeys
    }
}

export class MDSModalFieldCodeModel extends MDSModalContainer {
    constructor (props) {
        const {
            field, // [Object, isRequired]
            scope, // [String, isRequired]
        } = props
        super()

        this.field = field
        this.scope = scope
    }
}

export class MDSModalHintModel extends MDSModalContainer {
    constructor (props) {
        const {
            message, // [String, isRequired]
        } = props
        super()

        this.message = message
    }
}

export class MDSModalIframeModel extends MDSModalContainer {
    constructor (props) {
        const {
            src, // [String, isRequired]
        } = props
        super()

        this.src = src
    }
}

export class MDSModalNewCustomObjectModel extends MDSModalContainer {
    constructor (props) {
        const {
            usedKeys = [], // [Array, isRequired]
        } = props
        super()

        this.usedKeys = usedKeys
    }
}

export class MDSModalNewFieldModel extends MDSModalContainer {
    constructor (props) {
        const {
            parent, // [Object, isRequired]
            scope, // [String, isRequired]
            usedKeys, // [Array, isRequired]
        } = props
        super()

        this.parent = parent
        this.scope = scope
        this.usedKeys = usedKeys
    }
}


// WEBPACK FOOTER //
// ./src/models/modal-datasets.model.js